import createReactComponent from '../createReactComponent';
export default createReactComponent('cross-off', 'IconCrossOff', [
  ['path', { d: 'M16 12h3v-4h-5v-5h-4v3m-2 2h-3v4h5v9h4v-7', key: 'svg-0' }],
  ['path', { d: 'M3 3l18 18', key: 'svg-1' }],
]);
